import React, { useState } from "react";
import { Modal, Steps, Upload, Button, Table, Select, message, Form, Typography, Spin } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import Papa from "papaparse";
import { uri } from "../backendUri";
import axiosApi from "../axiosApi/axiosApi";

const { Step } = Steps;
const { Dragger } = Upload;
const { Option, OptGroup } = Select;



const CsvUploadModal = ({ visible, onClose, catogories }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [csvData, setCsvData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [columnMapping, setColumnMapping] = useState();
    const [loading, setLoading] = useState(false);



    const handleUpload = (file) => {
        Papa.parse(file, {
            complete: (result) => {
                if (result.data.length > 1) {
                    const columns = result.data[0].filter((col) => col);
                    setHeaders(columns);
                    setCsvData(result.data.slice(1));

                    // Pre-fill mappings with default values
                    let defaultMappings = {};
                    columns.forEach((col) => {
                        defaultMappings[col] = findDefaultValue(col) || "Do not import";
                    });
                    setColumnMapping(defaultMappings);

                    message.success("CSV uploaded successfully!");
                    setCurrentStep(1);
                } else {
                    message.error("Invalid CSV file. Please check the format.");
                }
            },
            header: false,
        });
        return false;
    };

    const fieldOptions = [
        "Do not import",
        "-----------------",
        "ID", "Type", "SKU", "Name", "Published", "Short description", "Description", "Stock",
        "Tax status", "Tax class", "Categories", "Tags (comma separated)", "Tags (space separated)", "Shipping class", "Images",
        "Parent", "Upsells", "Cross-sells", "Grouped products",
        "Allow customer reviews?", "Purchase note", "Position",
        "Swatches Attributes", "Woo Variation Gallery Images", "Brands", "Import as meta data",
        "Backorders allowed?",
        "GTIN, UPC, EAN, or ISBN", "In stock?", "Is featured?", "Low stock amount",
        "Sold individually?", "Visibility in catalog", "Weight (lbs)",
        {
            label: "Price",
            options: ["Regular price", "Sale price", "Date sale price starts", "Date sale price ends"],
        },
        {
            label: "Dimensions",
            options: ["Length (in)", "Width (in)", "Height (in)"],
        },
        {
            label: "Downloads",
            options: ["Download ID", "Download name", "Download URL", "Download limit", "Download expiry days"],
        },
        {
            label: "Attributes",
            options: ["Attribute name", "Attribute value(s)", "Is a global attribute?", "Attribute visibility", "Default attribute"],
        },
        {
            label: "External product",
            options: ["External URL", "Button text"],
        },

    ];


    const handleMappingChange = (csvColumn, woocommerceField) => {
        setColumnMapping((prev) => ({
            ...prev,
            [csvColumn]: woocommerceField,
        }));
    };
    const findDefaultValue = (field) => {


        for (const option of fieldOptions) {
            if (typeof option === "string" && option === field) {
                return field;
            } else if (option.options?.includes(field)) {
                return field;
            }
        }

        if (field === 'Tags') {
            return "Tags (comma separated)"
        }
        const attributeMatch = field.match(/^Attribute \d+ (name|value\(s\)|visible|global|default)$/);
        if (attributeMatch) {
            const attributeType = attributeMatch[1];

            const attributeMappings = {
                "name": "Attribute name",
                "value(s)": "Attribute value(s)",
                "visible": "Attribute visibility",
                "global": "Is a global attribute?",
                "default": "Default attribute",
            };

            const genericAttribute = attributeMappings[attributeType];

            return fieldOptions.find((opt) =>
                typeof opt === "object" && opt.label === "Attributes" && opt.options.includes(genericAttribute)
            )
                ? genericAttribute
                : undefined;
        }
        if (field.includes('Meta:')) {
            return 'import as meta data'
        }

        return undefined;
    };

    const getCategoryIds = (productCategories, wooCategories = catogories) => {
        let categoryIds = [];

        productCategories?.forEach((categoryName) => {
            const matchedCategory = wooCategories.find((cat) => cat.name.toLowerCase() === categoryName.toLowerCase());

            if (matchedCategory) {
                categoryIds.push({ id: matchedCategory.id });

                if (matchedCategory.parent && !categoryIds.some(cat => cat.id === matchedCategory.parent)) {
                    categoryIds.push({ id: matchedCategory.parent });
                }
            }
        });

        return categoryIds;
    };

    const formatWooCommerce = (wooCategories) => {
        if (!csvData || !csvData.length || !headers || !headers.length) {
            throw new Error("Invalid CSV file: No data or headers found.");
        }

        return csvData.map((row) => {
            let formattedProduct = {
                name: "",
                brands: "",
                type: "simple",
                regular_price: "",
                sale_price: "",
                description: "",
                short_description: "",
                sku: "",
                stock_status: "instock",
                stock_quantity: "",
                categories: [],
                images: [],
                attributes: [],
                meta_data: [],
                weight: "",
                dimensions: {
                    length: "",
                    width: "",
                    height: ""
                },
                tax_status: "",
                tax_class: "",
                manage_stock: false,
                backorders: "no",
                sold_individually: false,
                upsell_ids: [],
                cross_sell_ids: [],
                purchase_note: "",
                reviews_allowed: true,
                tags: [],
                shipping_class: ""
            };

            let productCategories = [];

            headers.forEach((header, index) => {
                const value = row[index] || "";
                const mappedField = columnMapping?.[header] !== undefined ? columnMapping[header] : header;

                if (mappedField === "Do not import" || mappedField.toLowerCase() === "id") return;
                console.log(mappedField, 'asdfsd');

                switch (mappedField) {
                    case "Name":
                        formattedProduct.name = value + 'testing';
                        break;
                    case "Brands":
                        formattedProduct.brands = value;
                        break;
                    case "Type":
                        formattedProduct.type = value.toLowerCase();
                        break;
                    case "Regular price":
                        formattedProduct.regular_price = value;
                        break;
                    case "Sale price":
                        formattedProduct.sale_price = value;
                        break;
                    case "Description":
                        formattedProduct.description = value;
                        break;
                    case "Short description":
                        formattedProduct.short_description = value;
                        break;
                    case "SKU":
                        formattedProduct.sku = value;
                        break;
                    case "Stock":
                        break;
                    case "In stock?":
                        const stockQty = parseInt(value);
                        formattedProduct.stock_quantity = isNaN(stockQty) ? "" : stockQty;
                        formattedProduct.manage_stock = formattedProduct.stock_quantity !== "";
                        formattedProduct.stock_status = formattedProduct.stock_quantity > 0 ? "instock" : "outofstock";
                        break;
                    case "Categories":
                        productCategories = [...new Set(value.split(",").flatMap(cat =>
                            cat.split(">").map(subCat => subCat.trim())
                        ))];
                        break;
                    case "Images":
                        formattedProduct.images = value
                            ? value.split(",").map(url => ({ src: url.trim() }))
                            : [];
                        break;
                    case "weight (lbs)":
                        formattedProduct.weight = value;
                        break;
                    case "Length (in)":
                        formattedProduct.dimensions.length = value;
                        break;
                    case "Width (in)":
                        formattedProduct.dimensions.width = value;
                        break;
                    case "Height (In)":
                        formattedProduct.dimensions.height = value;
                        break;
                    case "Tax status":
                        formattedProduct.tax_status = value;
                        break;
                    case "Tax class":
                        formattedProduct.tax_class = value;
                        break;
                    case "Bbackorders":
                        formattedProduct.backorders = value;
                        break;
                    case "Sold individually":
                        formattedProduct.sold_individually = value.toLowerCase() === "yes";
                        break;
                    case "Upsells":
                        formattedProduct.upsell_ids = value.split(",").map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                        break;
                    case "Cross sells":
                        formattedProduct.cross_sell_ids = value.split(",").map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                        break;
                    case "Purchase note":
                        formattedProduct.purchase_note = value;
                        break;
                    case "Aallow customer reviews":
                        formattedProduct.reviews_allowed = value.toLowerCase() === "yes";
                        break;
                    case "Tags":
                        formattedProduct.tags = value.split(",").map(tag => ({ name: tag.trim() }));
                        break;
                    case "Shipping class":
                        formattedProduct.shipping_class = value;
                        break;
                    default:
                        const attributeMatch = header.match(/^Attribute (\d+) Name$/i);
                        if (attributeMatch) {
                            const attributeName = value.trim().toLowerCase();
                            const attributeMap = {
                                "colors": { id: 11, position: 1 },
                                "capacity": { id: 3, position: 0 },
                                "cosmetic condition": { id: 2, position: 2 }
                            };

                            if (attributeMap[attributeName]) {
                                formattedProduct.attributes.push({
                                    id: attributeMap[attributeName].id,
                                    name: attributeName.charAt(0).toUpperCase() + attributeName.slice(1),
                                    slug: `pa_${attributeName.replace(/\s+/g, "-")}`,
                                    position: attributeMap[attributeName].position,
                                    options: row[index + 1]?.split(",").map(opt => opt.trim()) || [],
                                    visible: true,
                                    variation: true
                                });
                            }
                        } else if (mappedField === "Import as meta data" || header.toLowerCase().startsWith("meta")) {
                            formattedProduct.meta_data.push({ key: header, value });
                        } else {
                            formattedProduct[mappedField] = value;
                        }
                }
            });
            console.log(productCategories, 'catorogoes');

            if (productCategories.length > 0) {

                formattedProduct.categories = getCategoryIds(productCategories);
            }

            return formattedProduct;
        });
    };


    const handleSaveCsvProductsFile = async (data) => {
        setLoading(true)
        try {
            const response = await axiosApi.post(`/csv-file-product-create`, data.slice(0, 2));

            if (response.data && response.data.success) {
                message.success(response.data.message || 'CSV file uploaded successfully!');
                return { success: true, message: response.data.message };
            } else {
                message.warning('Unexpected response from server.');
                return { success: false, message: 'Unexpected response from server.' };
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Something went wrong!';
            message.error(errorMsg);
            return { success: false, message: errorMsg };
        } finally {
            setLoading(false)
            onClose(false)
        }
    };

    return (

        <Modal open={visible} onCancel={() => onClose(false)} footer={null} width={700} style={{ marginTop: -60 }}>
            <Steps current={currentStep} size="small" style={{ marginBottom: 20, marginTop: 20 }}>
                <Step title="Upload CSV" />
                <Step title="Map Columns" />
                <Step title="Save" />
            </Steps>

            {currentStep === 0 && (
                <Dragger beforeUpload={handleUpload} showUploadList={false} multiple={false}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag CSV file to this area</p>
                    <p className="ant-upload-hint">Ensure the file is formatted correctly.</p>
                </Dragger>
            )}

            {currentStep === 1 && (
                <>
                    <Typography>CsvMap CSV fields to products</Typography>
                    <Typography>Select fields from your CSV file to map against products fields, or to ignore during import.</Typography>
                    <Form layout="vertical">
                        <Table
                            dataSource={headers.map((header, index) => ({
                                key: header,
                                field: header,
                                sample: csvData[0]?.[index] ?? "-",
                            }))}
                            columns={[
                                {
                                    title: "Column Name",
                                    dataIndex: "field",
                                    key: "field",
                                    render: (text, record) => (
                                        <div>
                                            <strong>{text}</strong>
                                            <br />
                                            <span style={{ color: "#888" }}>{record?.sample}</span>
                                        </div>
                                    ),
                                },
                                {
                                    title: "Map to Field",
                                    key: "mapping",
                                    render: (_, record) => {
                                        return <Select
                                            showSearch
                                            placeholder="Select WooCommerce Field"
                                            value={
                                                columnMapping && columnMapping[record?.field] !== undefined
                                                    ? columnMapping[record?.field]
                                                    : findDefaultValue(record?.field)
                                            }
                                            onChange={(value) => handleMappingChange(record?.field, value)}
                                            style={{ width: "100%" }}
                                            allowClear
                                        >
                                            {fieldOptions.map((group) =>
                                                typeof group === "string" ? (
                                                    <Option key={group} value={group}>
                                                        {group}
                                                    </Option>
                                                ) : (
                                                    <OptGroup key={group?.label} label={group?.label}>
                                                        {group.options.map((option) => (
                                                            <Option key={option} value={option}>
                                                                {option}
                                                            </Option>
                                                        ))}
                                                    </OptGroup>
                                                )
                                            )}
                                        </Select>
                                    },
                                },
                            ]}
                            pagination={false}
                        />
                    </Form>
                </>
            )}

            {currentStep === 2 && (
                <div style={{ textAlign: "center" }}>
                    <p>Click "Save" to import the mapped products.</p>
                    <Button
                        type="primary"
                        style={{ marginTop: 20, background: "#1677ff", color: "white" }}
                        onClick={() => {
                            let formattedProducts = formatWooCommerce(); // Get correctly mapped product data
                            handleSaveCsvProductsFile(formattedProducts)
                            console.log("Final WooCommerce Data:", formattedProducts);
                        }}
                        disabled={csvData.length === 0}
                        loading={loading}
                    >
                        Save
                    </Button>
                </div>
            )}

            <div style={{ marginTop: 20, textAlign: "right" }}>
                {currentStep > 0 && (
                    <Button onClick={() => setCurrentStep(currentStep - 1)} style={{ marginRight: 8 }}>
                        Back
                    </Button>
                )}
                {currentStep < 2 && (
                    <Button type="primary"
                        style={{ background: "#1677ff", color: "white" }}
                        onClick={() => setCurrentStep(currentStep + 1)}>
                        Next
                    </Button>
                )}
            </div>

        </Modal>

    );
};

export default CsvUploadModal;
